<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <em class="boton_herramientas sombraModales" v-b-tooltip.hover.v-light.topright="'Mostrar herramientas'" @click="mostrarModalHerramientas()"></em>
    <div v-if="navegandoMovil">
    <b-modal  v-model="mostrarModalHdx "
                   centered
                   no-close-on-backdrop
                   hide-header-close
                   hide-header
                   hide-footer
                   size="xl">
      <div v-if="apartadoModalHerramientas === 1" class="container-fluid cew-9 mb-5">
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span style="color: #53BACA">Herramientas del paciente </span>
          </div>
          <div>
            <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="mostrarModalHerramientas()"></em>
          </div>
        </div>
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span>Herramientas/</span>
          </div>
          <div v-if="!diagInicial">
            <subir-herramienta-modal :idPacienteArchivos="idPacienteExp" :carpetaPrincipal="carpetaPrincipal" :carpetaArchivo="carpetaArchivo" @carpetaSeccionadaArchivo="carpetaSeccionadaArchivo" @carpetaSeccionada="carpetaSeccionada"></subir-herramienta-modal>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row mt-2">
            <div class='col-12 col-sm-12 col-md-3' style='text-align: left;' v-for="(item, index) of listaCarpetas" :key="index">
              <div @click="carpetaSeccionada(item)" style="cursor: pointer;">
                <img alt="Herramientas" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFISURBVHgB7de/TcNAFMfx3zsngUgIhYYWZwRv4EzACjQUVJgJDBPgFlGQVZgg2cCGkgJMEaL43+OdaCIkBBflyBX3kSKfo1z0le2zbMDz7KL1nbucE0VIZTjCP2KgIML0/IRu8D3s/olv5RcJdomQSdzV11A85Bw2hBwOaBjjizEVPb3zWrfxh3zzXvOPEwZyjo/2FEYDBZsCIJbNtJfMluHzok1/m1B3jEXToeoCHO8HsE11rK5lG/51wsuylUCGbUpWwykMlasWtulrzPjW8FZ16ActDvsKAWEr9P/oo7QethF9SvVnm/QCG/Yo1GO6nK3sXzCGCN3E7trfECNInQyTtNjRMFkIcJQPM+XDTPkwUz7MlA8z5cNM6bASDpIwmsMxzPwoT9mVfiV36aiVivhMZdHBXJ6xI12JHdMNhHqSRcMCnmfZJ3OWYVQseWw4AAAAAElFTkSuQmCC">
                <p style='font-weight: bolder; font-size: 13px'>{{item.nombreRuta}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="apartadoModalHerramientas === 2" class="container-fluid cew-9">
        <div class="row d-flex justify-content-between" style="font-weight: bolder;">
          <div>
            <span style="color: #53BACA">Herramientas del paciente</span>
          </div>
          <div>
            <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="mostrarModalHerramientas()"></em>
          </div>
        </div>
        <div class="row d-flex justify-content-center" style="font-weight: bolder;">
          <div>
            <span><em class="chevron_claro" style="height: 14px; transform: rotate(90deg); position: relative; top: 2px; cursor: pointer" @click="irAtras()"></em>Herramientas/{{carpetaPrincipal.nombreRuta}}</span>
          </div>
          <div v-if="!diagInicial">
            <subir-herramienta-modal :idPacienteArchivos="idPacienteExp" :carpetaPrincipal="carpetaPrincipal" :carpetaArchivo="carpetaArchivo" @carpetaSeccionadaArchivo="carpetaSeccionadaArchivo" @carpetaSeccionada="carpetaSeccionada"></subir-herramienta-modal>
          </div>
        </div>
        <div v-if="listaCarpetasDirectorio.length === 0 && !loader" class="text-center align-items-center flex--wrap" style=" display: grid; place-items: center; margin-top:4%;">
          <img alt="herramientas" width="130" src="../../../assets/icons/no-result.png">
          <p class="txt-not-found text-center">No se encontraron herramientas</p>
        </div>
        <div class="container-fluid">
          <div class="row mt-2">
            <div class='col-12 col-sm-12 col-md-3' style='text-align: left;' v-for="(item, index) of listaCarpetasDirectorio" :key="index">
              <div @click="carpetaSeccionadaArchivo(item)" style="cursor: pointer;">
                <img alt="herramientas" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFISURBVHgB7de/TcNAFMfx3zsngUgIhYYWZwRv4EzACjQUVJgJDBPgFlGQVZgg2cCGkgJMEaL43+OdaCIkBBflyBX3kSKfo1z0le2zbMDz7KL1nbucE0VIZTjCP2KgIML0/IRu8D3s/olv5RcJdomQSdzV11A85Bw2hBwOaBjjizEVPb3zWrfxh3zzXvOPEwZyjo/2FEYDBZsCIJbNtJfMluHzok1/m1B3jEXToeoCHO8HsE11rK5lG/51wsuylUCGbUpWwykMlasWtulrzPjW8FZ16ActDvsKAWEr9P/oo7QethF9SvVnm/QCG/Yo1GO6nK3sXzCGCN3E7trfECNInQyTtNjRMFkIcJQPM+XDTPkwUz7MlA8z5cNM6bASDpIwmsMxzPwoT9mVfiV36aiVivhMZdHBXJ6xI12JHdMNhHqSRcMCnmfZJ3OWYVQseWw4AAAAAElFTkSuQmCC">
                <p style='font-weight: bolder; font-size: 13px'>{{item.Name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="apartadoModalHerramientas === 3" class="container-fluid cew-9 mb-5">
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span style="color: #53BACA">Herramientas del paciente </span>
          </div>
          <div>
            <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="mostrarModalHerramientas()"></em>
          </div>
        </div>
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span> <em class="chevron_claro mr-1" style="height: 14px; transform: rotate(90deg); position: relative; top: 2px; cursor: pointer" @click="irAtras()"></em>Herramientas/{{carpetaPrincipal.nombreRuta}}/{{carpetaArchivo.Name}}</span>
          </div>
          <div v-if="!diagInicial">
            <subir-herramienta-modal :idPacienteArchivos="idPacienteExp" :carpetaPrincipal="carpetaPrincipal" :carpetaArchivo="carpetaArchivo" @carpetaSeccionadaArchivo="carpetaSeccionadaArchivo" @carpetaSeccionada="carpetaSeccionada"></subir-herramienta-modal>
          </div>
        </div>
        <div v-if="listArchivos.length === 0 && !loader" class="text-center align-items-center flex--wrap" style=" display: grid; place-items: center; margin-top:4%;">
          <img alt="herramientas" width="130" src="../../../assets/icons/no-result.png">
          <p class="txt-not-found text-center">No se encontraron herramientas</p>
        </div>
        <cards-herramientas :listArchivos="listArchivos" :listaVisor="listaVisor" :navegandoMovil="true"></cards-herramientas>
      </div>
      <div v-if="loader" class="d-flex justify-content-center align-items-center">
        <div class="your-div">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </b-modal>
    </div>
    <div v-else>
    <div class="modal-movil" v-if="mostrarModalHdx" @mousedown="dragStart" :style="{ right: x === -713 ? 100 + '%': 'initial', left: x !== -713 ? x + 'px': 'initial', top: y + 'px', width: width + 'px', height: height + 'px' }" >
      <div v-if="apartadoModalHerramientas === 1" class="container-fluid cew-9 mb-5">
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span style="color: #53BACA">Herramientas del paciente </span>
          </div>
          <div>
            <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="mostrarModalHerramientas()"></em>
          </div>
        </div>
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span>Herramientas/</span>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row mt-2">
            <div class='col-12 col-sm-12 col-md-3' style='text-align: left;' v-for="(item, index) of listaCarpetas" :key="index">
              <div @click="carpetaSeccionada(item)" style="cursor: pointer;">
                <img alt="herramientas" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFISURBVHgB7de/TcNAFMfx3zsngUgIhYYWZwRv4EzACjQUVJgJDBPgFlGQVZgg2cCGkgJMEaL43+OdaCIkBBflyBX3kSKfo1z0le2zbMDz7KL1nbucE0VIZTjCP2KgIML0/IRu8D3s/olv5RcJdomQSdzV11A85Bw2hBwOaBjjizEVPb3zWrfxh3zzXvOPEwZyjo/2FEYDBZsCIJbNtJfMluHzok1/m1B3jEXToeoCHO8HsE11rK5lG/51wsuylUCGbUpWwykMlasWtulrzPjW8FZ16ActDvsKAWEr9P/oo7QethF9SvVnm/QCG/Yo1GO6nK3sXzCGCN3E7trfECNInQyTtNjRMFkIcJQPM+XDTPkwUz7MlA8z5cNM6bASDpIwmsMxzPwoT9mVfiV36aiVivhMZdHBXJ6xI12JHdMNhHqSRcMCnmfZJ3OWYVQseWw4AAAAAElFTkSuQmCC">
                <p style='font-weight: bolder; font-size: 13px'>{{item.nombreRuta}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="apartadoModalHerramientas === 2" class="container-fluid cew-9 m-3">
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span style="color: #53BACA">Herramientas del paciente</span>
          </div>
          <div>
            <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="mostrarModalHerramientas()"></em>
          </div>
        </div>
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span><em class="chevron_claro mr-1" style="height: 14px; transform: rotate(90deg); position: relative; top: 2px; cursor: pointer" @click="irAtras()"></em>Herramientas/{{carpetaPrincipal.nombreRuta}}</span>
          </div>
          <div v-if="!diagInicial">
            <subir-herramienta-modal :idPacienteArchivos="idPacienteExp" :carpetaPrincipal="carpetaPrincipal" :carpetaArchivo="carpetaArchivo" @carpetaSeccionadaArchivo="carpetaSeccionadaArchivo" @carpetaSeccionada="carpetaSeccionada"></subir-herramienta-modal>
          </div>
        </div>
        <div v-if="listaCarpetasDirectorio.length === 0 && !loader" class="text-center align-items-center flex--wrap" style=" display: grid; place-items: center; margin-top:4%;">
          <img alt="herramientas" width="130" src="../../../assets/icons/no-result.png">
          <p class="txt-not-found text-center">No se encontraron herramientas</p>
        </div>
        <div class="container-fluid">
          <div class="row mt-2">
            <div class='col-12 col-sm-12 col-md-3' style='text-align: left;' v-for="(item, index) of listaCarpetasDirectorio" :key="index">
              <div @click="carpetaSeccionadaArchivo(item)" style="cursor: pointer;">
                <img alt="Herramientas" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFISURBVHgB7de/TcNAFMfx3zsngUgIhYYWZwRv4EzACjQUVJgJDBPgFlGQVZgg2cCGkgJMEaL43+OdaCIkBBflyBX3kSKfo1z0le2zbMDz7KL1nbucE0VIZTjCP2KgIML0/IRu8D3s/olv5RcJdomQSdzV11A85Bw2hBwOaBjjizEVPb3zWrfxh3zzXvOPEwZyjo/2FEYDBZsCIJbNtJfMluHzok1/m1B3jEXToeoCHO8HsE11rK5lG/51wsuylUCGbUpWwykMlasWtulrzPjW8FZ16ActDvsKAWEr9P/oo7QethF9SvVnm/QCG/Yo1GO6nK3sXzCGCN3E7trfECNInQyTtNjRMFkIcJQPM+XDTPkwUz7MlA8z5cNM6bASDpIwmsMxzPwoT9mVfiV36aiVivhMZdHBXJ6xI12JHdMNhHqSRcMCnmfZJ3OWYVQseWw4AAAAAElFTkSuQmCC">
                <p style='font-weight: bolder; font-size: 13px'>{{item.Name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="apartadoModalHerramientas === 3" class="container-fluid cew-9 mb-5">
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span style="color: #53BACA">Herramientas del paciente </span>
          </div>
          <div>
            <em class="close_x_svg"  style="float: right; height: 12px; cursor: pointer" @click="mostrarModalHerramientas()"></em>
          </div>
        </div>
        <div class="row d-flex justify-content-between m-2" style="font-weight: bolder;">
          <div>
            <span> <em class="chevron_claro mr-1" style="height: 14px; transform: rotate(90deg); position: relative; top: 2px; cursor: pointer" @click="irAtras()"></em>Herramientas/{{carpetaPrincipal.nombreRuta}}/{{carpetaArchivo.Name}}</span>
          </div>
          <div v-if="!diagInicial">
            <subir-herramienta-modal :idPacienteArchivos="idPacienteExp" :carpetaPrincipal="carpetaPrincipal" @carpetaSeccionadaArchivo="carpetaSeccionadaArchivo" @carpetaSeccionada="carpetaSeccionada"></subir-herramienta-modal>
          </div>
        </div>
        <div v-if="listArchivos.length === 0 && !loader" class="text-center align-items-center flex--wrap" style=" display: grid; place-items: center; margin-top:4%;">
          <img alt="Herramientas" width="130" src="../../../assets/icons/no-result.png">
          <p class="txt-not-found text-center">No se encontraron herramientas</p>
        </div>
        <cards-herramientas :listArchivos="listArchivos" :listaVisor="listaVisor" :maxheight="height" :navegandoMovil="false"></cards-herramientas>
      </div>
      <div v-if="loader" class="d-flex justify-content-center align-items-center">
        <div class="your-div">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
      <div class="resize-handle" @mousedown.stop="resizeStart"><em class="expandir mr-1" style="height: 14px; transform: rotate(90deg);"></em></div>
    </div>
    </div>
  </div>
</template>

<script>

import CardsHerramientas from "@/version5/herramientas/componentes/cardsHerramientas";
import SubirHerramientaModal from "@/version5/herramientas/componentes/SubirHerramientaModal";
import {S3Client, S3ServiceException,ListObjectsV2Command,  GetObjectCommand, NoSuchKey} from "@aws-sdk/client-s3"
import moment from "moment";
import {AwsService} from "../../../apiServices/aws/AwsService";

export default {
  name: "HerramientasModal",
  components: {
  SubirHerramientaModal,
  CardsHerramientas},
  props: {
    idPacienteExp: Number,
    diagInicial: {
        default: false,
        type: Boolean
      }
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      awsServicio: new AwsService(),
      token: null,
      x: -713,
      y: 0,
      width: 600,
      height: 750,
      isDragging: false,
      isResizing: false,
      initialMouseX: 0,
      initialMouseY: 0,
      mostrarModalHdx:false,
      listaCarpetas:[],
      apartadoModalHerramientas: 1,
      carpetaPrincipal: null,
      listaCarpetasDirectorio:[],
      loader: false,
      listArchivos:[],
      listaVisor:[],
      nombreArchivo:null,
      widthAux: 0,
      heightAux: 0,
      carpetaArchivo: null,
      navegandoMovil: false
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWS();
    this.obtenerRutasHija(true);
    this.navegandoMovil = this.detectarDispositivoMovil();
    await this.validarTokenAWS();

  },
  computed: {
    esImagen() {
      let exprecionRegular = /\.(png|jpe?g)$/i;

      if (exprecionRegular.test(this.nombreArchivo)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    dragStart(event) {
      this.isDragging = true;
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;

      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.dragEnd);
    },
    drag(event) {
      if (!this.isDragging) return;
      this.x += event.clientX - this.initialMouseX;
      this.y += event.clientY - this.initialMouseY;
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;
    },
    dragEnd() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.dragEnd);
    },
    resizeStart(event) {

        this.isResizing = true;
        this.initialMouseX = event.clientX;
        this.initialMouseY = event.clientY;

        document.addEventListener('mousemove', this.resize);
        document.addEventListener('mouseup', this.resizeEnd);
    },
    resize(event) {
      this.widthAux = this.width + (event.clientX - this.initialMouseX)
      this.heightAux =  this.height +  event.clientY - this.initialMouseY
      this.heightAux =  this.height +  event.clientY - this.initialMouseY;
      if(this.widthAux >= 600 && this.heightAux >= 750){
        if (!this.isResizing) return;
        this.width += event.clientX - this.initialMouseX;
        this.height += event.clientY - this.initialMouseY;
        this.initialMouseX = event.clientX;
        this.initialMouseY = event.clientY;
     }
    },
    resizeEnd() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.resize);
      document.removeEventListener('mouseup', this.resizeEnd);
    },
    irAtras(){
      this.apartadoModalHerramientas = this.apartadoModalHerramientas-1;
      if(this.apartadoModalHerramientas === 1){
        this.obtenerRutasHija(false)
      }else if (this.apartadoModalHerramientas === 2){
        this.carpetaSeccionada(this.carpetaPrincipal)
      }
    },
    mostrarModalHerramientas(){
      this.mostrarModalHdx = !this.mostrarModalHdx;
      if(this.mostrarModalHdx){
        this.obtenerRutasHija(true);
      }
    },
    obtenerRutasHija(inicio) {
      this.loader = true;
      this.listaCarpetas = [];
      const params = {
        idRutaPadre: 5
      }
      this.$http
          .post(
              this.$api +
              "rutaExpediente/listarRutasHijas", params  )
          .then((response) => {
            this.listaCarpetas = response.data.data;
            if(inicio){
              this.carpetaSeccionada(this.listaCarpetas[1])
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },
    async carpetaSeccionada(carpeta) {
      await this.validarTokenAWS();
      try {
        this.carpetaPrincipal = carpeta;
        this.apartadoModalHerramientas = 2;
        this.listaCarpetasDirectorio = [];
        this.loader = true;
        let config = {
          region: this.token.regionBucket,
          credentials: {
            accessKeyId: this.token.accessKeyId,
            secretAccessKey: this.token.secretAccessKey,
            sessionToken: this.token.sessionToken,
          },
        }

        let ruta = carpeta.path.replace("#id_paciente", this.idPacienteExp.toString());
        const prefixToRemove = "DOCSPRUEBA/";if (ruta.startsWith(prefixToRemove)) {  ruta = ruta.substring(prefixToRemove.length);}
        const client = new S3Client(config);
        const input = {
          Bucket: this.token.nombreBucket,
          Prefix: ruta
        };
        const command = new ListObjectsV2Command(input);
        const response = await client.send(command);
        if (response.Contents !== undefined){
          this.archivosObtenidos = response.Contents;
          response.Contents.forEach((datos) => {
            let rutasSeparadas = datos.Key.toString().split('/')
            let extension = rutasSeparadas[rutasSeparadas.length - 1].split('.');
            let name = rutasSeparadas[rutasSeparadas.length - 2];
            let carpeta = {
              Name: name,
              extension: extension[1] != null ? "carpeta" : extension[1],
              TimeCreated: datos.LastModified
            };
            let archivoRepetido = false;
            this.listaCarpetasDirectorio.forEach(archivo => {
              if(archivo.Name === carpeta.Name){
                archivoRepetido = true;
              }
            })
            if(this.listaCarpetasDirectorio.length === 0 || !archivoRepetido){
              this.listaCarpetasDirectorio.push(carpeta)
            }
          })
        }
        this.loader = false;
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async carpetaSeccionadaArchivo(carpeta) {
      await this.validarTokenAWS();
      this.listArchivos = [];
      this.listaVisor = [];
      let config = {
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      }
      const client = new S3Client(config);

      try {
        this.archivosObtenidos.filter(archivo => {
          let rutasSeparadas = archivo.Key.toString().split('/');
          rutasSeparadas.pop();
          if (carpeta.Name === rutasSeparadas[rutasSeparadas.length - 1]) {
            return archivo;
          }
        }).map(async (archivoObtenido) => {
          // Verificamos la extensión antes de enviar la solicitud a S3
          let rutasSeparadas = archivoObtenido.Key.toString().split('/');
          let extension = rutasSeparadas[rutasSeparadas.length - 1].split('.');
          let ext = extension[1].toLowerCase();

          // Solo hacemos la petición si es una imagen o PDF
          if (["jpg", "png", "jpeg", "pdf"].includes(ext)) {
            const input = {
              Bucket: this.token.nombreBucket,
              Key: archivoObtenido.Key,
            };
            const command = new GetObjectCommand(input);
            const response = await client.send(command);

            const responseS3 = await new Response(response.Body);
            const imageBlob = await responseS3.blob();
            const reader = new FileReader();

            reader.onloadend = () => {
              archivoObtenido.imagenBase64 = reader.result.split(',')[1];
              let datos = {
                Name: rutasSeparadas[rutasSeparadas.length - 1],
                extension: ext,
                TimeCreated: archivoObtenido.LastModified,
                Length: archivoObtenido.Size,
                imagenBase64: archivoObtenido.imagenBase64,
              };

              // Si es una imagen, agregarla al visor
              if (["jpg", "png", "jpeg"].includes(ext)) {
                this.listaVisor.push(datos);
              }

              this.listArchivos.push(datos); // Agregar el archivo con base64
            };

            reader.readAsDataURL(imageBlob);
          } else {
            // Si no es una imagen o PDF, solo lo agregamos con imagenBase64 como null
            let datos = {
              Name: rutasSeparadas[rutasSeparadas.length - 1],
              extension: ext,
              TimeCreated: archivoObtenido.LastModified,
              Length: archivoObtenido.Size,
              imagenBase64: null, // No solicitamos base64 si no es imagen o PDF
            };
            this.listArchivos.push(datos); // Agregar el archivo con imagenBase64 como null
          }
        });
      } catch (caught) {
        if (caught instanceof NoSuchKey) {
          console.error(
              `Error from S3 while getting object "${this.archivosObtenidos[0].Key}" from "${this.token.nombreBucket}". No such key exists.`,
          );
        } else if (caught instanceof S3ServiceException) {
          console.error(
              `Error from S3 while getting object from ${this.token.nombreBucket}.  ${caught.name}: ${caught.message}`,
          );
        } else {
          throw caught;
        }
      }
      this.listaVisor = this.listArchivos.filter((archivo) => archivo.extension === 'jpg' ||
          archivo.extension === 'png' ||
          archivo.extension === 'jpeg')
      this.carpetaArchivo = carpeta;
      this.apartadoModalHerramientas = 3;
    },
    detectarDispositivoMovil() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;


      // Dispositivos móviles
      if (/android/i.test(userAgent)) {
        return true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
      }

      // Si no es ninguno de los anteriores, asumimos que es un PC
      return false;
    },

  }
}
</script>

<style scoped>
.sombraModales {
  filter: drop-shadow(2px 1px 4px rgba(0, 0, 0, 0.25));
}

.modal-movil {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  /* box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1); */
  cursor: move;
  z-index: 1000;
  border-radius: 23px;
}

.resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background-color: #ffff;
  cursor: nwse-resize;
}
.icono-herramienta{
  border-radius: 49%;
  -webkit-box-shadow: 0px 10px 10px -6px black;
  box-shadow: 0px 10px 10px -6px black;
  background: #77C9D5 !important;
  border-color: #77C9D5 !important;
}
</style>
